import React from "react";

export default function QuickUsers({ user, isAnonymus, eleRef }) {
    return (
        <div className="experts-details discussion-expert">
            <div className="userProfile">
            <span className="experts-photo">
                {user.userPhoto && user.userPhoto != '' && user.userPhoto.toLowerCase() != "null" ?
                    <img src={user.userPhoto.replace("http://", "https://")} onError={(e) => { e.target.src = 'https://cdn.fcglcdn.com/brainbees/parenting/img/m/default-img.png'}} alt="" className="loadingImg" />
                    :
                    <img src="https://cdn.fcglcdn.com/brainbees/parenting/img/m/default-img.png" alt="" className="loadingImg" />
                }
            </span>
           
            <span className="experts-name discussion-publisher">
                {user.userName && user.userName != '' && parseInt(isAnonymus) == 0 ?
                    <span className="exp-name M14_42">{user.userName}</span>
                    :
                    <span className="exp-name M14_42">Community User</span>
                }
                {user.userDesc && user.userDesc != '' && parseInt(isAnonymus) == 0 ?
                    <span className="R13_9e experts-desc">{user.userDesc}</span>
                    :
                    <span className="R13_9e experts-desc"></span>
                }
            </span>
            </div>
            {user.commentDateTime && user.commentDateTime != '' ?
                <span className="experts-last-online-time R13_9e">{user.commentDateTime}</span>
                :
                <span className="experts-last-online-time R13_9e"></span>
            }
        </div>
    );
}
